import { Container, Title, Tabs, Group, Badge, Alert } from '@mantine/core';
import { IconUsers, IconBuildingStore, IconChartBar, IconExclamationCircle } from '@tabler/icons-react';
import { useSession } from '../../api';

const AdminLayout = ({ children, activeTab, onTabChange }) => {
  const { isAdmin } = useSession();

  if (!isAdmin) {
    return (
      <Container size="md" py="xl">
        <Alert
          icon={<IconExclamationCircle size="1rem" />}
          color="red"
          title="Access Denied"
        >
          You do not have permission to access the admin area.
        </Alert>
      </Container>
    );
  }

  return (
    <Container size="xl" py="md">
      <Group align="center" mb="lg">
        <Title order={1} size="h2">Admin Dashboard</Title>
        <Badge color="pink" variant="light">
          Admin
        </Badge>
      </Group>

      <Tabs value={activeTab} onChange={onTabChange} mb="xl">
        <Tabs.List>
          <Tabs.Tab value="stats" leftSection={<IconChartBar size="0.8rem" />}>
            Dashboard
          </Tabs.Tab>
          <Tabs.Tab value="users" leftSection={<IconUsers size="0.8rem" />}>
            Users
          </Tabs.Tab>
          <Tabs.Tab value="sellers" leftSection={<IconBuildingStore size="0.8rem" />}>
            Sellers
          </Tabs.Tab>
        </Tabs.List>

        {children}
      </Tabs>
    </Container>
  );
};

export default AdminLayout;
